import React, { useCallback, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';
import { Trash2 } from 'lucide-react';

import { addRecentAsset, clearRecentAssets } from '@/shared/lib/storage/recentAssets';
import { buildAssetDetailUrl } from '@/shared/lib/url';
import type { RecentAssetItem } from '@/shared/types/assetList';
import { AssetListCard } from '@/shared/ui/AssetListCard';

import { RecentAssetsTab } from '@/widgets/home/RecentAssetsTab';

import styles from './RecentAssetsCard.module.css';

export const RecentAssetsCard: React.FC = () => {
  const navigate = useNavigate();
  const [refreshKey, setRefreshKey] = useState(0);

  const handleAssetClick = useCallback(
    (asset: RecentAssetItem) => {
      try {
        addRecentAsset({
          id: asset.id,
          name: asset.name,
          type: asset.type,
          fqn: asset.fqn,
          viewedAt: dayjs().toISOString(),
          ...(asset.projectId && { projectId: asset.projectId }),
          ...(asset.experimentId && { experimentId: asset.experimentId }),
          ...(asset.experimentName && { experimentName: asset.experimentName }),
        });
      } catch (error) {
        console.error('Failed to add recent asset:', error);
      }
      const detailUrl = asset.fqn.startsWith('/experiments/')
        ? asset.fqn
        : buildAssetDetailUrl(asset.type, asset.fqn, undefined, asset.id, asset.projectId);
      navigate(detailUrl);
    },
    [navigate]
  );

  const handleClearAll = useCallback(() => {
    clearRecentAssets();
    setRefreshKey((prev) => prev + 1);
  }, []);

  const actions = (
    <button type="button" onClick={handleClearAll} className={styles.clearButton}>
      <Trash2 size={14} />
      <span>전체 기록 지우기</span>
    </button>
  );

  return (
    <AssetListCard title="최근 본 항목" actions={actions}>
      <RecentAssetsTab key={refreshKey} maxItems={10} onAssetClick={handleAssetClick} showActions={false} />
    </AssetListCard>
  );
};
